module.exports = __webpack_public_path__ + "static/media/logo.db6d2f0a.png";